import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatSingups = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        end: item.end && moment(item.end),
        start: item.start && moment(item.start),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchSingups,
    create: createSingup,
    update: updateSingup,
    delete: deleteSingups
} = createCrudActions('SINGUP', "Fichaje", formatSingups);
